import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { Router } from '@angular/router';
import { User } from 'app/shared/models/User';
import { SharedService } from 'app/shared/services/shared.service';
import { CompanyAuditService } from 'app/company-audit/services/company-audit.service';
import { LendersService } from 'app/lenders/services/lenders.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UserAuditService } from 'app/user-audit/services/user-audit.service';
import { MyAuditListModel } from 'app/user-audit/models/my-audit-list.model';
import { CompanyUserModel } from 'app/shared/models/company-user.model';
import { ICompanyAuditDetailsModel } from 'app/company-audit/models/company-audit-details.model';
import { CompanyAuditModuleViewModel } from 'app/company-audit/models/company-audit-module-view.model';
import { Result } from 'app/core/models/result';
import { ReportCompanyAuditModuleModel } from 'app/company-audit/models/report-company-audit-module';
import { ReportSelectorCompanies } from '../../../company-audit/models/report-selector-companies.model';
import { ReportSelectorUsers } from '../../../company-audit/models/report-selector-users.model';
import { ReportSelectorModules } from '../../../company-audit/models/report-selector-modules.model';
import { SummaryRating } from '../../../shared/models/summaryRating.model';
import * as moment from 'moment';
import { LendersModel } from '../../../lenders/models/lenders.model';
import { CompanyListModel } from '../../../company/models/company-list.model';

@Component({
    selector: 'app-lender-dashboard',
    templateUrl: './lender-dashboard.component.html',
    styleUrls: ['./lender-dashboard.component.css']
})
export class LenderDashboardComponent implements OnInit {
    headerTitle: IHeaderTitle;
    errors: string[];
    userUrl: Router;
    user: User;
    lender: LendersModel;
    companiesList: CompanyListModel[];


    constructor(
        private userAuditService: UserAuditService,
        private sharedService: SharedService,
        private lendersService: LendersService,
        private companyAuditService: CompanyAuditService,
        private fb: FormBuilder
    ) {
    }

    ngOnInit() {
        this.sharedService.currentUser.subscribe(user => {
            this.user = user;
            this.lendersService.getLenderForContact(user.id).subscribe(
                lender => {
                    this.lender = lender;
                    this.lendersService.getAllowedCompanies(lender.id).subscribe(
                        companies => {
                            this.companiesList = companies
                        }
                    )
                },
                error => {
                    this.errors = (<Result>error).errorList;
                }
            )
        });
        

    }

    
}
